export default __webpack_public_path__ + "static/media/18AV.25285809.jpg";